import { Component, HostListener, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DatasetService } from "src/app/services/dataset/dataset.service";
import { Entry } from "src/app/_shared/models/publication-results.model";
import { LOCAL_STORAGE_KEYS } from "src/app/shared/constants/storage-keys";

@Component({
    selector: "tdms-workbench-pubfacet",
    templateUrl: "./workbench-pubfacet.component.html",
    styleUrls: ["./workbench-pubfacet.component.scss"],
    standalone: false
})
export class WorkbenchPubfacetComponent implements OnInit {
  @Input() facets: any[];
  @Input() isPublication: boolean;

  screenWidth: number;

  constructor(private router: Router, private dataSetService: DatasetService) {}

  ngOnInit() {
    this.screenWidth = window.innerWidth;
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.screenWidth = window.innerWidth;
  }

  getFacet(facet): string {
    //console.log(this.facets);
    const facetName: string = this.isPublication
      ? facet.displayValue
      : facet.name;

    if (window.innerWidth > 1279) {
      const len = Math.floor(window.innerWidth * 0.019);
      return facetName.length > len
        ? facetName.slice(0, len) + "..."
        : facetName;
    } else if (window.innerWidth > 959) {
      const len = Math.floor(window.innerWidth * 0.034);
      return facetName.length > len
        ? facetName.slice(0, len) + "..."
        : facetName;
    } else {
      const len = Math.floor(window.innerWidth * 0.032);
      return facetName.length > len
        ? facetName.slice(0, len) + "..."
        : facetName;
    }

    return facetName;
  }

  goToDataset() {
    this.router.navigateByUrl("/dataset");
  }

  navigateToPublicationPage() {
    localStorage.setItem(LOCAL_STORAGE_KEYS.PUB_CART_STATE, JSON.stringify({ showCart: true }));
    this.router.navigate(["/dataset"], { state: { showCart: true } });
  }
}
